module.exports = __webpack_public_path__ + "img/38_23.cc20acbd.png";